import { coreDefaultTheme } from '@kite-js/theme';
import { ULTheme, ULThemeBuilder } from '@theme/types';
import { coreWikibuyTheme } from './theme-wikibuy';

const WikibuyThemeBuilder: ULThemeBuilder = (cultureCode?: string, appId?: string) => {
    const theme: ULTheme = {
        ...coreDefaultTheme,
        ...coreWikibuyTheme,
        logoUrl: '',
        background: {
            image: '',
            color: 'rgba(247, 247, 247, 1)',
            position: '0 0',
            size: 'contain',
        },
        faviconUrl: 'https://cdn6.agoda.net/images/mvc/default/favicon/wikibuy/cap1-shopping.ico',
        input: {
            ...coreDefaultTheme.input,
            borderRadius: 'S',
        },
        tab: {
            ...coreDefaultTheme.tab,
            padding: '12px 8px 12px 8px',
        },
    };

    return theme;
};

export default WikibuyThemeBuilder;
